import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT, DATA_LIMIT_KEY} from "../../app/constants";

const importHistoryOrder = createSlice({
	name: "importHistoryOrder",
	initialState: {
		loading: false,
		error: null,
		filter:{
			excelId: 0,
			page : 1,
			limit : (localStorage.getItem(DATA_LIMIT_KEY) != undefined) ? parseInt(localStorage.getItem(DATA_LIMIT_KEY)) : DATA_LIMIT,
		},
		items: [],
		pagination : {
			page : 1,
			limit : (localStorage.getItem(DATA_LIMIT_KEY) != undefined) ? parseInt(localStorage.getItem(DATA_LIMIT_KEY)) : DATA_LIMIT,
			totalRows: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const importHistoryOrderActions = importHistoryOrder.actions;
//Reducers
export const importHistoryOrderReducer = importHistoryOrder.reducer;
//Selectors
export const importHistoryOrderItemsSelector = (state) => state.importHistoryOrder.items;
export const importHistoryOrderLoadingSelector = (state) => state.importHistoryOrder.loading;
export const importHistoryOrderErrorSelector = (state) => state.importHistoryOrder.error;
export const importHistoryOrderFilterSelector = (state) => state.importHistoryOrder.filter;
export const importHistoryOrderPaginationSelector = (state) => state.importHistoryOrder.pagination;